export default "__VITE_ASSET__BLS08gdh__"